export default __webpack_public_path__ + "static/media/640_portfolio04-jp-mobile.5c4ce7bc.png";